const textProps = {
  text: "Profile completion",
  value: 80,
  color: "pink",
};
export default textProps;
